export default "__VITE_ASSET__InnF0NGm__"